<template>
  <v-container fill-height fluid grid-list-xl>
    <v-row justify="center">
      <v-col cols="12">
        <material-card
          color="green"
          flat
          full-width
          title="Статистика заказов"
        >
          <router-link to="/orders/list">
            Заказы
          </router-link>
          <v-data-table
            :headers="headers"
            :items="data"
            :loading="loading"
            class="elevation-1"
            :disable-pagination="true"
          >
            <template #body.prepend>
              <tr>
                <td>
                  <v-menu
                    v-model="dateCreatedVis"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template #activator="{ on, attrs }">
                      <v-text-field
                        v-model="labelFilterCreatedAt"
                        readonly
                        v-bind="attrs"
                        clearable
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filterCreatedAt"
                      no-title
                      locale="RU"
                      range
                      @change="dateCreatedVis = false"
                    ></v-date-picker>
                  </v-menu>
                  <v-menu
                    v-model="dateDiffVis"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template #activator="{ on, attrs }">
                      <a
                        onclick="return false"
                        href="#"
                        v-bind="attrs"
                        v-on="on"
                        style="text-decoration: none"
                      >
                        Сравнить с периодом
                        <span>
                          <v-icon
                            v-if="diffCreatedAt.length > 0"
                            small
                            @click="diffCreatedAt = []"
                          >
                            mdi-window-close
                          </v-icon>
                        </span>
                      </a>
                      <span>{{ labelDiffCreatedAt }}</span>
                    </template>
                    <v-date-picker
                      v-model="diffCreatedAt"
                      no-title
                      locale="RU"
                      range
                      @change="dateDiffVis = false"
                    ></v-date-picker>
                  </v-menu>
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>
                  <v-select
                    v-model="filterStatus"
                    :items="statusList"
                    clearable
                  />
                </td>
              </tr>
              <tr>
                <td>Итого</td>
                <td v-if="totalData.sumOfOrdersCount.length > 1">
                  {{ totalData.sumOfOrdersCount[0] }}<br /> <span v-bind:style="{ color: getCompareColor(totalData.sumOfOrdersCount[0], totalData.sumOfOrdersCount[1]) }">
                    {{ getComparePercentValue(totalData.sumOfOrdersCount[0], totalData.sumOfOrdersCount[1]) }}%
                  </span>
                  <v-icon
                    small
                    v-bind:style="{ color: getCompareColor(totalData.sumOfOrdersCount[0], totalData.sumOfOrdersCount[1]) }"
                  >
                    {{ getCompareIcon(totalData.sumOfOrdersCount[0], totalData.sumOfOrdersCount[1]) }}
                  </v-icon> <br />{{ totalData.sumOfOrdersCount[1] }}
                </td>
                <td v-else>{{ totalData.sumOfOrdersCount[0] }}</td>
                <td v-if="totalData.sumOfOrdersTotalSum.length > 1">
                  {{ totalData.sumOfOrdersTotalSum[0] }} <br /><span v-bind:style="{ color: getCompareColor(totalData.sumOfOrdersTotalSum[0], totalData.sumOfOrdersTotalSum[1]) }">
                    {{ getComparePercentValue(totalData.sumOfOrdersTotalSum[0], totalData.sumOfOrdersTotalSum[1]) }}%
                  </span>
                  <v-icon
                    small
                    v-bind:style="{ color: getCompareColor(totalData.sumOfOrdersTotalSum[0], totalData.sumOfOrdersTotalSum[1]) }"
                  >
                    {{ getCompareIcon(totalData.sumOfOrdersTotalSum[0], totalData.sumOfOrdersTotalSum[1]) }}
                  </v-icon><br /> {{ totalData.sumOfOrdersTotalSum[1] }}
                </td>
                <td v-else>{{ totalData.sumOfOrdersTotalSum[0] }}</td>
                <td v-if="totalData.avgOfOrdersAverageSum.length > 1">
                  {{ totalData.avgOfOrdersAverageSum[0] }} <br /><span v-bind:style="{ color: getCompareColor(totalData.avgOfOrdersAverageSum[0], totalData.avgOfOrdersAverageSum[1]) }">
                    {{ getComparePercentValue(totalData.avgOfOrdersAverageSum[0], totalData.avgOfOrdersAverageSum[1]) }}%
                  </span>
                  <v-icon
                    small
                    v-bind:style="{ color: getCompareColor(totalData.avgOfOrdersAverageSum[0], totalData.avgOfOrdersAverageSum[1]) }"
                  >
                    {{ getCompareIcon(totalData.avgOfOrdersAverageSum[0], totalData.avgOfOrdersAverageSum[1]) }}
                  </v-icon><br /> {{ totalData.avgOfOrdersAverageSum[1] }}
                </td>
                <td v-else>{{ totalData.avgOfOrdersAverageSum[0] }}</td>
                <td v-if="totalData.sumOfOffersCount.length > 1">
                  {{ totalData.sumOfOffersCount[0] }} <br /><span v-bind:style="{ color: getCompareColor(totalData.sumOfOffersCount[0], totalData.sumOfOffersCount[1]) }">
                    {{ getComparePercentValue(totalData.sumOfOffersCount[0], totalData.sumOfOffersCount[1]) }}%
                  </span>
                  <v-icon
                    small
                    v-bind:style="{ color: getCompareColor(totalData.sumOfOffersCount[0], totalData.sumOfOffersCount[1]) }"
                  >
                    {{ getCompareIcon(totalData.sumOfOffersCount[0], totalData.sumOfOffersCount[1]) }}
                  </v-icon><br /> {{ totalData.sumOfOffersCount[1] }}
                </td>
                <td v-else>{{ totalData.sumOfOffersCount[0] }}</td>
                <td></td>
              </tr>
            </template>
            <template #item.createdAt="{ item }">
              {{ new Date(item.createdAt * 1000).toLocaleString("ru-RU") }}
            </template>
            <template #item.status="{ item }">
              {{ getStatus(item) }}
            </template>
          </v-data-table>
        </material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { getOrdersStatistics } from '@/graphql/orders_statistics'
export default {
  Name: 'OrdersStatistics',
  layout: 'dashboard',
  apollo: {
    ordersStatistics: {
      query: getOrdersStatistics,
      result ({ data, loading }) {
        if (data?.ordersStatistics) {
          this.data = this.getOrderedData(data.ordersStatistics)
          this.totals = []
          this.totals.push(...data.ordersStatistics.map(item => ({
            avgOfOrdersAverageSum: item?.avgOfOrdersAverageSum,
            sumOfOffersCount: item?.sumOfOffersCount,
            sumOfOrdersCount: item?.sumOfOrdersCount,
            sumOfOrdersTotalSum: item?.sumOfOrdersTotalSum
          })))
        }
        this.loading = false
      },
      variables () {
        const input = {}
        if (this.filterStatus) {
          input.status = this.filterStatus
        }
        if (this.filterCreatedAt) {
          input.date = this.filterCreatedAt
        } else {
          const yesterday = new Date()
          yesterday.setDate(yesterday.getDate() - 1)
          const yesterdayDateRange = [yesterday.getDate(), yesterday.getMonth() + 1, yesterday.getFullYear()].join('-')
          input.date = [yesterdayDateRange, yesterdayDateRange]
          const yesterdayPickerFormat = [yesterday.getFullYear(), yesterday.getMonth() + 1, yesterday.getDate()].join('-')
          this.filterCreatedAt = [yesterdayPickerFormat, yesterdayPickerFormat]
        }
        if (this.diffCreatedAt) {
          input.compareWithDate = this.diffCreatedAt
        }
        // input.compareWithDate = [
        //   '01.10.2020',
        //   '31.10.2020'
        // ]
        return {
          input
        }
      }
    }
  },
    data () {
    return {
      search: '',
      statusList: [
        { value: 'NEW', text: 'Новый' },
        { value: 'IN_PROCESS', text: 'В процессе' },
        { value: 'IN_DELIVERY', text: 'Доставка в процессе' },
        { value: 'DELETED', text: 'Удален' },
        { value: 'SENT', text: 'Отправлен' },
        { value: 'RETURN', text: 'Возвращен' }
      ],
      options: {},
      loading: false,
      data: [],
      totals: [],
      filterStatus: '',
      filterCreatedAt: '',
      diffCreatedAt: [],
      dateCreatedVis: false,
      dateDiffVis: false,
      totalDesserts: 0,
      deleteDialog: false,
      headers: [
        {
          sortable: false,
          text: 'Дата',
          value: 'date'
        },
        {
          sortable: false,
          text: 'Кол-во заказов',
          value: 'ordersCount'
        },
        {
          sortable: false,
          text: 'Общая сумма',
          value: 'ordersTotalSum'
        },
        {
          sortable: false,
          text: 'Средний чек',
          value: 'ordersAverageSum'
        },
        {
          sortable: false,
          text: 'Кол-во товаров',
          value: 'offersCount'
        },
        {
          sortable: false,
          text: 'Статус',
          value: 'status'
        }
      ]
    }
  },
  computed: {
    labelFilterCreatedAt () {
      if (this.filterCreatedAt.length === 1) {
        return this.formatDatePickerDate(this.filterCreatedAt[0])
      } else if (this.filterCreatedAt.length === 2) {
        if (this.filterCreatedAt[0] === this.filterCreatedAt[1]) {
          return this.formatDatePickerDate(this.filterCreatedAt[0])
        } else {
          return this.formatDatePickerDate(this.filterCreatedAt[0]) + ' - ' + this.formatDatePickerDate(this.filterCreatedAt[1])
        }
      }

      return ''
    },
    labelDiffCreatedAt () {
      if (this.diffCreatedAt.length === 1) {
        return this.formatDatePickerDate(this.diffCreatedAt[0])
      } else if (this.diffCreatedAt.length === 2) {
        if (this.diffCreatedAt[0] === this.diffCreatedAt[1]) {
          return this.formatDatePickerDate(this.diffCreatedAt[0])
        } else {
          return this.formatDatePickerDate(this.diffCreatedAt[0]) + ' - ' + this.formatDatePickerDate(this.diffCreatedAt[1])
        }
      }

      return ''
    },
    totalData () {
      return {
        sumOfOrdersCount: this.totals.map(item => parseInt(item.sumOfOrdersCount)),
        sumOfOrdersTotalSum: this.totals.map(item => parseInt(item.sumOfOrdersTotalSum)),
        avgOfOrdersAverageSum: this.totals.map(item => parseInt(item.avgOfOrdersAverageSum)),
        sumOfOffersCount: this.totals.map(item => parseInt(item.sumOfOffersCount))
      }
    }
  },
  methods: {
    formatDatePickerDate (date) {
      if (!date) {
        return null
      }

      const [year, month, day] = date.split('-')
      return `${day.padStart(2, '0')}-${month.padStart(2, '0')}-${year}`
    },
    toggleDeleteDialog (value, slug) {
      this.deleteDialog = value
          ? slug
          : null
    },
    getStatus (item) {
      const ret = this.statusList.filter(row => row.value === item.status)
      if (ret.length > 0) {
        return ret[0].text
      }

      return item.status
    },
    getCompareColor (origin, diff) {
      const res = this.compareResults(origin, diff)
      return res.color
    },
    getCompareIcon (origin, diff) {
      const res = this.compareResults(origin, diff)
      return res.icon
    },
    getComparePercentValue (origin, diff) {
      const res = this.compareResults(origin, diff)
      return res.percent
    },
    compareResults (origin, diff) {
      if (!isNaN(origin) && !isNaN(diff)) {
        return {
          color: origin > diff ? 'green' : 'red',
          icon: origin > diff ? 'mdi-arrow-up' : 'mdi-arrow-down',
          percent: (origin > 0 && diff > 0) ? Math.abs(Math.round(100 - origin / diff * 100)) : (origin > diff ? origin * 100 : diff * 100)
        }
      }
      return {
        color: '',
        percent: 0
      }
    },
    getOrderedData (data) {
      let full = []
      const ret = []
      if (data.length > 0) {
        full = data[0]
      }
      if (data.length > 1) {
        full = data[0]
        if (data[1]?.date) {
          full.date.push(...data[1]?.date)
        }
        if (data[1]?.ordersCount) {
          full.ordersCount.push(...data[1]?.ordersCount)
        }
        if (data[1]?.ordersTotalSum) {
          full.ordersTotalSum.push(...data[1]?.ordersTotalSum)
        }
        if (data[1]?.ordersAverageSum) {
          full.ordersAverageSum.push(...data[1]?.ordersAverageSum)
        }
        if (data[1]?.offersCount) {
          full.offersCount.push(...data[1]?.offersCount)
        }
      }
      if (full?.date?.length) {
        for (let i = 0; i <= full.date.length; ++i) {
          ret.push({
            date: full.date[i],
            ordersCount: full.ordersCount[i],
            ordersTotalSum: full.ordersTotalSum[i],
            ordersAverageSum: full.ordersAverageSum[i],
            offersCount: full.offersCount[i]
          })
        }
      }
      return ret
    }
  }
}
</script>
